import HttpClientToken from '../../services/HttpClientToken';

import { AutoridadDomicilioProps, AutoridadProps, AutoridadTitularProps, defaultAutoridadTitular } from '../../interfaces/catalogos/AutoridadInterface';
import { defaultDomicilio, DomicilioProps } from '../../interfaces/comun/DomicilioInterface';

export const ObtenerAutoridades = () => {

    return new Promise<AutoridadProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Autoridad/ObtenerAutoridades/', token)
            .then( ({ data } : { data : AutoridadProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const Autoridades = () => {

    return new Promise<AutoridadTitularProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Autoridad/', token)
            .then( ({ data } : { data : AutoridadTitularProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerAutoridadesMaterias = ( id: number ) => {

    return new Promise<AutoridadProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Autoridad/ObtenerAutoridadesMaterias/${ id }`, token)
            .then( ({ data } : { data : AutoridadProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarAutoridad = ( params: AutoridadProps ) => {

    return new Promise<AutoridadTitularProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Autoridad/Actualizar', params, token)
            .then( ({ data } : { data : AutoridadTitularProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAutoridadTitular } );
            });

        }

    });

}

export const AgregarAutoridad = ( params: AutoridadProps ) => {

    return new Promise<AutoridadTitularProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Autoridad/Agregar', params, token)
            .then( ({ data } : { data : AutoridadTitularProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAutoridadTitular } );
            });

        }

    });

}

export const AgregarDomicilio = ( params: AutoridadDomicilioProps ) => {

    return new Promise<DomicilioProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Autoridad/AgregarDomicilio', params, token)
            .then( ({ data } : { data : DomicilioProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultDomicilio } );
            });

        }

    });

}
